require.register("app/product/price/UpdateView", function(exports, require, module){
  $0
  
});

